import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match?.[1];
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        // NOTE (Phase A2): the backend no longer returns session_token
        // in the JSON body. The HttpOnly session cookie is set by this
        // response and the browser handles it automatically. Do not
        // store any token client-side.
        // Iteration 80 Phase 2 — if MFA is required, route the user to
        // /login/2fa; the session cookie is set but ``mfa_pending``.
        if (res.data?.mfa_required) {
          setUser({ mfa_required: true, email: res.data?.user?.email || "" });
          window.history.replaceState({}, "", "/login/2fa");
          navigate("/login/2fa", { replace: true });
          return;
        }
        setUser(res.data?.user || null);
        // Clean URL fragment then navigate.
        window.history.replaceState({}, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: res.data?.user } });
      } catch (_e) {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[color:var(--bg-0)] text-[color:var(--text-2)]">
      <div className="font-display text-base">Signing you in…</div>
    </div>
  );
}
